import {Routes} from '@angular/router';
import {HomeComponent} from './components/home/home.component';
import {SearchComponent} from './components/search/search.component';
import {SubscriptionsComponent} from './components/subscriptions/subscriptions.component';
import {ContactComponent} from './components/contact/contact.component';
import {LoginComponent} from './components/login/login.component';
import {RealEstateDetailsComponent} from './components/real-estate-details/real-estate-details.component';
import {RealEstateReportComponent} from './components/real-estate-report/real-estate-report.component';
import {UserComponent} from './components/user/user.component';
import {FavoritesComponent} from './components/favorites/favorites.component';
import {AboutUsComponent} from './components/about-us/about-us.component';
import {TermsAndConditionsComponent} from './components/static/terms-and-conditions/terms-and-conditions.component';
import {LegalNoticeComponent} from './components/static/legal-notice/legal-notice.component';
import {CookiePolicyComponent} from './components/static/cookie-policy/cookie-policy.component';
import {PrivacyPolicyComponent} from './components/static/privacy-policy/privacy-policy.component';
import {CancellationRenewalPolicyComponent} from './components/static/cancellation-renewal-policy/cancellation-renewal-policy.component';
import {CreateAccountComponent} from './components/create-account/create-account.component';
import {CheckoutSuccessfulComponent} from './components/static/checkout-successful/checkout-successful.component';
import {
  PasswordResetSuccessfulComponent
} from './components/static/password-reset-successful/password-reset-successful.component';
import {Article01Component} from './components/static/articles/article-01/article-01.component';
import {Article02Component} from './components/static/articles/article-02/article-02.component';
import {Article03Component} from './components/static/articles/article-03/article-03.component';
import {Article04Component} from './components/static/articles/article-04/article-04.component';
import {Article05Component} from './components/static/articles/article-05/article-05.component';
import {Article06Component} from './components/static/articles/article-06/article-06.component';
import {Article07Component} from './components/static/articles/article-07/article-07.component';
import {Article08Component} from './components/static/articles/article-08/article-08.component';
import {Article09Component} from './components/static/articles/article-09/article-09.component';
import {Article10Component} from './components/static/articles/article-10/article-10.component';
import {ArticlesComponent} from './components/articles/articles.component';

export const routes: Routes = [
  {path: '', redirectTo: 'home', pathMatch: "full"},
  {path: 'home', component: HomeComponent},
  {path: 'login', component: LoginComponent},
  {path: 'criar-conta', component: CreateAccountComponent},
  {path: 'busca', component: SearchComponent},
  {path: 'planos', component: SubscriptionsComponent},
  {path: 'contato', component: ContactComponent},
  {path: 'propriedade/:id', component: RealEstateDetailsComponent},
  {path: 'propriedade/:id/relatorio', component: RealEstateReportComponent},
  {path: 'minha-conta', component: UserComponent},
  {path: 'usuario', redirectTo: 'minha-conta'},
  {path: 'favoritos', component: FavoritesComponent},
  {path: 'notificacoes', component: UserComponent, data: {tab: 'notificacoes'}},
  {path: 'sobre-nos', component: AboutUsComponent},
  {path: 'termos-e-condicoes', component: TermsAndConditionsComponent},
  {path: 'aviso-lagal', component: LegalNoticeComponent},
  {path: 'politica-de-cookies', component: CookiePolicyComponent},
  {path: 'politica-de-privacidade', component: PrivacyPolicyComponent},
  {path: 'politica-de-cancelamento-e-renovacao-automatica', component: CancellationRenewalPolicyComponent},
  {path: 'assinatura-concluida', component: CheckoutSuccessfulComponent},
  {path: 'senha-alterada-com-sucesso', component: PasswordResetSuccessfulComponent},
  {path: 'artigos', component: ArticlesComponent},
  {path: 'artigos/1', redirectTo: 'como-comecar-participar-leiloes-caixa-guia-iniciantes', pathMatch: 'full'},
  {path: 'artigos/2', redirectTo: 'analise-matricula-imovel-antes-dar-lance-leilao', pathMatch: 'full'},
  {path: 'artigos/3', redirectTo: 'o-que-e-lance-minimo-leilao-imovel', pathMatch: 'full'},
  {path: 'artigos/4', component: Article04Component},
  {path: 'artigos/5', redirectTo: 'vale-a-pena-comprar-imovel-em-leilao', pathMatch: 'full'},
  {path: 'artigos/6', redirectTo: 'quanto-dinheiro-preciso-para-comecar-em-leilao-imobiliario', pathMatch: 'full'},
  {path: 'artigos/7', redirectTo: 'leilao-judicial-vs-extrajudicial-qual-a-diferenca', pathMatch: 'full'},
  {path: 'artigos/8', redirectTo: 'o-que-significa-venda-direta-caixa', pathMatch: 'full'},
  {path: 'artigos/9', redirectTo: 'como-evitar-prejuizo-em-leilao-imobiliario', pathMatch: 'full'},
  {path: 'artigos/10', redirectTo: 'da-para-financiar-imovel-de-leilao', pathMatch: 'full'},
  {path: 'como-comecar-participar-leiloes-caixa-guia-iniciantes', component: Article01Component},
  {path: 'analise-matricula-imovel-antes-dar-lance-leilao', component: Article02Component},
  {path: 'o-que-e-lance-minimo-leilao-imovel', component: Article03Component},
  {path: 'vale-a-pena-comprar-imovel-em-leilao', component: Article05Component},
  {path: 'quanto-dinheiro-preciso-para-comecar-em-leilao-imobiliario', component: Article06Component},
  {path: 'leilao-judicial-vs-extrajudicial-qual-a-diferenca', component: Article07Component},
  {path: 'o-que-significa-venda-direta-caixa', component: Article08Component},
  {path: 'como-evitar-prejuizo-em-leilao-imobiliario', component: Article09Component},
  {path: 'da-para-financiar-imovel-de-leilao', component: Article10Component},

];
